export default __webpack_public_path__ + "static/media/img-whatsapp.ccf92eda.png";